import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const remove = (id, params) =>
  requestsTemplates.remove(mainPath, `/mapping_fields/${id}`, params);
